// Generated by scripts/generate-build-info.js during npm run build.
export const BUILD_INFO = {
  "app": "ManuCalc",
  "version": "1.0.0",
  "buildTimestamp": "2026-09-10T17:51:04.372Z",
  "firebaseProject": "manucalc-1d2b5",
  "hostingSite": "manucalc-1d2b5"
};
